module.exports = __webpack_public_path__ + "0e7915553cf17d7a81a8429dcf3d8028.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/clarityScale/SI2@2x.png
// module id = 821
// module chunks = 0